const { Bin, Item, Packer } = BinPacking3D;

async function addGiftBoxesOnUpdate(state, sectionsToRender = {}) {
  const removeState = await removeGiftBoxes(sectionsToRender);
  // console.log('🚀 ~ addGiftBoxesOnUpdate ~ removeState:', removeState);
  if (removeState.item_count === 0) {
    return { ...removeState };
  }
  if (!removeState) {
    return false;
  }

  const giftBoxes = await getGiftBoxes();

  if (giftBoxes.items.length > 0) {
    const body = JSON.stringify({ items: giftBoxes.items, ...sectionsToRender });
    // console.log('🚀 ~ addGiftBoxesOnUpdate ~ body:', body);
    // console.log('🚀 ~ state ~ { ...fetchConfig(), ...{ body } }:', { ...fetchConfig(), ...{ body } });

    const updateState = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      ...fetchConfig(),
      ...{ body },
    }).then((response) => response.json());
    return { ...state, sections: updateState.sections };
  } else {
    return { ...removeState };
  }
}

async function removeGiftBoxes(sectionsToRender) {
  // const cart2 = await cart.text();
  // console.log(cart2);
  const giftBoxElement = document.querySelector('[data-gift-box-keys]');
  if (!giftBoxElement || giftBoxElement.dataset.giftBoxKeys === '') {
    return false;
  }
  let updates = {};
  giftBoxElement.dataset.giftBoxKeys.split(',').forEach((key) => {
    updates[key] = 0;
  });
  // console.log('🚀 ~ giftBoxElement.dataset.giftBoxKeys.split ~ updates:', updates);

  const removeCall = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    ...fetchConfig(),
    body: JSON.stringify({ updates, ...sectionsToRender }),
  }).then((response) => {
    return response.json();
  });
  // console.log('🚀 ~ removeGiftBoxes ~ removeCall:', removeCall);

  return removeCall;
}

//Caclulate gift boxes

async function getGiftBoxes() {
  const response = await fetch('/?section_id=pw-gift-box-measurements');
  const html = await response.text();
  // console.log('🚀 ~ getGiftBoxes ~ html:', html);
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const giftBoxMeasurements = doc.querySelector('#shopify-section-pw-gift-box-measurements');

  // console.log('🚀 ~ getGiftBoxes ~ giftBoxMeasurements.innerText:', giftBoxMeasurements.innerText);
  const boxesAndProducts = JSON.parse(giftBoxMeasurements.innerText.replace(/,\s*([}\]])/g, '$1'));

  if (boxesAndProducts.products.length === 0) {
    return { items: [] };
  }

  let packedBoxes = [];
  let productsToPack = boxesAndProducts.products.map(
    (product) =>
      new Item(
        { name: product.name, id: product.id, gift_cart_index: product.gift_cart_index, sku: product.sku },
        product.length,
        product.width,
        product.height
      )
  );

  function tryPacking(boxes) {
    let count = 0;
    for (let box of boxes) {
      let bin = new Bin(box.name, box.length, box.width, box.height);
      let packer = new Packer();
      packer.addBin(bin);
      productsToPack.forEach((item) => {
        packer.addItem(item);
      });

      packer.pack();

      if (packer._unfitItems.length === 0) {
        packedBoxes.push({ box: box, items: bin.items });
        productsToPack = [];
        break;
      }
      if (count === boxes.length - 1 && packer._unfitItems.length > 0) {
        packedBoxes.push({ box: box, items: bin.items });
        productsToPack = packer.unfitItems;
      } else {
        count++;
      }
    }
  }

  let tries = 0;
  // Try initial boxes
  tryPacking(boxesAndProducts.boxes);

  // If there are still unfit products, try extra boxes
  while (productsToPack.length > 0) {
    tries++;
    if (tries > 20) {
      break;
    }
    tryPacking(boxesAndProducts.extra_boxes);
  }

  return {
    items: packedBoxes.map((box) => ({
      id: box.box.id,
      price: box.box.price,
      quantity: 1,
      properties: box.items.reduce((acc, item, index) => {
        acc[`_product_${index + 1}`] = `${item._name.name} - ${item._name.sku}`;
        return acc;
      }, {}),
    })),
  };
}
